(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["business-gifting-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(root) {
    if (root.dataset.dbReady) return;
    root.dataset.dbReady = '1';
    var track = root.querySelector('[data-db-track]');
    var prev = root.querySelector('[data-db-prev]');
    var next = root.querySelector('[data-db-next]');
    if (!track || !prev || !next) return;

    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    function step() {
      var slide = track.querySelector('.db-slide');
      return slide ? slide.getBoundingClientRect().width + 20 : track.clientWidth;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.db-biz').forEach(initCarousel);
  }

  // Add to cart (Shopify AJAX Cart API)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-db-add]');
    if (!btn) return;
    e.preventDefault();
    var label = btn.querySelector('[data-db-add-label]');
    var original = label ? label.textContent : '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    btn.setAttribute('aria-busy', 'true');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (btn.dataset.redirect === 'true') { window.location.href = root + 'cart'; return; }
        if (label) label.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () { if (label) label.textContent = original; }, 1800);
      })
      .catch(function () {
        if (label) label.textContent = 'Error';
        setTimeout(function () { if (label) label.textContent = original; }, 1800);
      })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["businessPage"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(root) {
    if (root.dataset.dbReady) return;
    root.dataset.dbReady = '1';
    var track = root.querySelector('[data-db-track]');
    var prev = root.querySelector('[data-db-prev]');
    var next = root.querySelector('[data-db-next]');
    if (!track || !prev || !next) return;

    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    function step() {
      var slide = track.querySelector('.db-slide');
      return slide ? slide.getBoundingClientRect().width + 20 : track.clientWidth;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.db-biz').forEach(initCarousel);
  }

  // Add to cart (Shopify AJAX Cart API)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-db-add]');
    if (!btn) return;
    e.preventDefault();
    var label = btn.querySelector('[data-db-add-label]');
    var original = label ? label.textContent : '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    btn.setAttribute('aria-busy', 'true');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (btn.dataset.redirect === 'true') { window.location.href = root + 'cart'; return; }
        if (label) label.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () { if (label) label.textContent = original; }, 1800);
      })
      .catch(function () {
        if (label) label.textContent = 'Error';
        setTimeout(function () { if (label) label.textContent = original; }, 1800);
      })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-load-more"] && !Shopify.designMode) return;
  try {
    
(function () {
  function items(grid) {
    return Array.prototype.filter.call(grid.children, function (el) { return el.nodeType === 1; });
  }

  function render(root) {
    var grid = document.querySelector(root.dataset.grid);
    if (!grid) return false;
    var list = items(grid);
    var total = list.length;
    var batch = parseInt(root.dataset.batch, 10) || 12;
    var shown = Math.min(parseInt(root.dataset.shown, 10) || batch, total);
    root.dataset.shown = shown;

    list.forEach(function (el, i) {
      if (i < shown) el.style.removeProperty('display');
      else el.style.display = 'none';
    });

    var done = shown >= total;
    var tpl = done ? root.dataset.done : root.dataset.status;
    root.querySelector('[data-cb-status]').textContent = tpl.replace('{shown}', shown).replace('{total}', total);
    var pct = total ? Math.round((shown / total) * 100) : 100;
    root.querySelector('[data-cb-fill]').style.width = pct + '%';
    root.querySelector('[data-cb-bar]').setAttribute('aria-valuenow', pct);
    root.querySelector('[data-cb-btn]').hidden = done;
    root.hidden = total === 0;
    return true;
  }

  function init(root, tries) {
    if (render(root)) return;
    if ((tries || 0) < 20) setTimeout(function () { init(root, (tries || 0) + 1); }, 250);
  }

  function initAll() {
    document.querySelectorAll('[data-cb-more]').forEach(function (r) { init(r, 0); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cb-btn]');
    if (!btn) return;
    var root = btn.closest('[data-cb-more]');
    var batch = parseInt(root.dataset.batch, 10) || 12;
    root.dataset.shown = (parseInt(root.dataset.shown, 10) || batch) + batch;
    render(root);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-toolbar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setState(root, open) {
    var drawer = root.querySelector('[data-cb-drawer]');
    var btn = root.querySelector('[data-cb-open]');
    if (!drawer) return;
    drawer.setAttribute('data-state', open ? 'open' : 'closed');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      var x = drawer.querySelector('.cb-drawer__x');
      if (x) x.focus();
    } else if (btn) {
      btn.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var root = e.target.closest('[data-cb-toolbar]');
    if (!root) return;
    if (e.target.closest('[data-cb-open]')) setState(root, true);
    else if (e.target.closest('[data-cb-close]')) setState(root, false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-cb-toolbar] [data-cb-drawer][data-state="open"]').forEach(function (d) {
      setState(d.closest('[data-cb-toolbar]'), false);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journal-stories"] && !Shopify.designMode) return;
  try {
    
(function () {
  var rootUrl = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };

  function apply() {
    var s = document.querySelector('[data-jr-search]');
    var q = s ? s.value.trim().toLowerCase() : '';
    var chip = document.querySelector('[data-jr-cat][aria-pressed="true"]');
    var cat = chip ? chip.getAttribute('data-jr-cat') : 'all';
    var visible = 0;
    document.querySelectorAll('[data-jr-post]').forEach(function (p) {
      var okCat = cat === 'all' || (p.getAttribute('data-tags') || '').split('|').indexOf(cat) > -1;
      var okQ = !q || (p.getAttribute('data-search') || '').indexOf(q) > -1;
      p.hidden = !(okCat && okQ);
      if (!p.hidden) visible++;
    });
    document.querySelectorAll('[data-jr-empty]').forEach(function (e) { e.hidden = visible > 0; });
  }

  function setCat(value) {
    document.querySelectorAll('[data-jr-cat]').forEach(function (c) {
      c.setAttribute('aria-pressed', c.getAttribute('data-jr-cat') === value ? 'true' : 'false');
    });
  }

  function openStory(handle) {
    var d = document.getElementById('jr-story-' + handle);
    if (!d || d.open) return;
    d.showModal();
    document.documentElement.style.overflow = 'hidden';
    if (window.history && history.replaceState) history.replaceState(null, '', '#story-' + handle);
  }

  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-jr-search]')) apply();
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var chip = t.closest && t.closest('[data-jr-cat]');
    if (chip) { setCat(chip.getAttribute('data-jr-cat')); apply(); return; }
    if (t.closest && t.closest('[data-jr-reset]')) {
      setCat('all');
      var s = document.querySelector('[data-jr-search]');
      if (s) s.value = '';
      apply();
      return;
    }
    var open = t.closest && t.closest('[data-jr-open]');
    if (open) { openStory(open.getAttribute('data-jr-open')); return; }
    var close = t.closest && t.closest('[data-jr-close]');
    if (close) { close.closest('dialog').close(); return; }
    if (t.matches && t.matches('dialog.jr-dlg')) t.close();
  });

  document.addEventListener('close', function (e) {
    if (e.target.matches && e.target.matches('dialog.jr-dlg')) {
      document.documentElement.style.overflow = '';
      if (window.history && history.replaceState) history.replaceState(null, '', location.pathname + location.search);
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-jr-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var after = (form.closest('[data-after]') || {}).dataset ? form.closest('[data-after]').dataset.after : 'stay';
    btn.setAttribute('aria-busy', 'true');
    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      if (after === 'cart') { window.location.href = rootUrl() + 'cart'; return; }
      btn.setAttribute('title', 'Added');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function () {
      btn.setAttribute('title', 'Could not add');
    }).then(function () { btn.removeAttribute('aria-busy'); });
  });

  function init() {
    var h = location.hash;
    if (h.indexOf('#story-') === 0) openStory(h.slice(7));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  var rootUrl = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };

  function setThumb(root, i) {
    root.querySelectorAll('[data-pm-thumb]').forEach(function (t, n) {
      if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
  }
  function goTo(root, i) {
    var track = root.querySelector('[data-pm-track]');
    if (!track) return;
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    setThumb(root, i);
  }
  function currentIndex(root) {
    var track = root.querySelector('[data-pm-track]');
    return track && track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
  }

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-pm-track]')) return;
    var root = t.closest('[data-pm]');
    if (root) setThumb(root, currentIndex(root));
  }, true);

  /* ----- variants ----- */
  function variants(root) {
    if (!root._pmV) {
      try { root._pmV = JSON.parse(root.querySelector('[data-pm-variants]').textContent); }
      catch (e) { root._pmV = []; }
    }
    return root._pmV;
  }
  function setButtons(root, ok, label) {
    var add = root.querySelector('[data-pm-add]');
    var buy = root.querySelector('[data-pm-buy]');
    var lab = root.querySelector('[data-pm-add-label]');
    if (add) add.disabled = !ok;
    if (buy) buy.disabled = !ok;
    if (lab) lab.textContent = label;
  }
  function onOptionChange(root) {
    var sel = [];
    root.querySelectorAll('[data-pm-option]').forEach(function (fs) {
      var c = fs.querySelector('input:checked');
      sel.push(c ? c.value : null);
    });
    var v = variants(root).filter(function (x) {
      return x.options.every(function (o, i) { return o === sel[i]; });
    })[0];
    if (!v) { setButtons(root, false, 'Unavailable'); return; }

    root.querySelector('[name="id"]').value = v.id;
    root.querySelector('[data-pm-price]').textContent = v.price;
    var cmp = root.querySelector('[data-pm-compare]');
    cmp.textContent = v.compare || '';
    cmp.hidden = !v.compare;
    var w = root.querySelector('[data-variant-weight]');
    if (w && v.weight) w.textContent = v.weight;
    setButtons(root, v.available, v.available ? 'Add to cart' : 'Sold out');

    if (window.history && history.replaceState) {
      history.replaceState({}, '', location.pathname + '?variant=' + v.id);
    }
    if (v.image) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pm-track] .pm-slide'));
      for (var i = 0; i < slides.length; i++) {
        if (Number(slides[i].dataset.imageId) === v.image) { goTo(root, i); break; }
      }
    }
  }

  /* ----- cart ----- */
  function addToCart(root) {
    var form = root.querySelector('[data-pm-form]');
    var id = Number(form.querySelector('[name="id"]').value);
    var qty = Math.max(1, Number(form.querySelector('[name="quantity"]').value) || 1);
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart.');
        return d;
      });
    });
  }
  function showMsg(root, text) {
    var m = root.querySelector('[data-pm-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.hidden = !text;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-pm-form]');
    if (!form) return;
    e.preventDefault();
    var root = form.closest('[data-pm]');
    var btn = root.querySelector('[data-pm-add]');
    var lab = root.querySelector('[data-pm-add-label]');
    var original = lab.textContent;
    showMsg(root, '');
    btn.setAttribute('aria-busy', 'true');
    addToCart(root)
      .then(function () {
        if (root.dataset.after === 'cart') { window.location.href = rootUrl() + 'cart'; return; }
        lab.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () { lab.textContent = original; }, 1800);
      })
      .catch(function (err) { showMsg(root, err.message); })
      .then(function () { btn.removeAttribute('aria-busy'); });
  });

  /* ----- clicks ----- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var root = t.closest && t.closest('[data-pm]');
    if (!root) return;

    var thumb = t.closest('[data-pm-thumb]');
    if (thumb) { goTo(root, Number(thumb.dataset.index)); return; }

    var step = t.closest('[data-pm-step]');
    if (step) {
      var input = root.querySelector('[name="quantity"]');
      var n = (Number(input.value) || 1) + Number(step.dataset.pmStep);
      input.value = Math.max(1, n);
      return;
    }

    if (t.closest('[data-pm-buy]')) {
      var buy = t.closest('[data-pm-buy]');
      showMsg(root, '');
      buy.setAttribute('aria-busy', 'true');
      addToCart(root)
        .then(function () { window.location.href = root.dataset.checkout; })
        .catch(function (err) { showMsg(root, err.message); buy.removeAttribute('aria-busy'); });
      return;
    }

    if (t.closest('[data-pm-reviews-btn]')) {
      var target = null;
      try { target = root.dataset.reviews ? document.querySelector(root.dataset.reviews) : null; } catch (err) {}
      target = target || document.querySelector('[id*="judgeme"], .jdgm-widget, [id*="reviews"]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    var dlg = root.querySelector('[data-pm-lb]');
    if (!dlg) return;
    var lt = dlg.querySelector('[data-pm-lb-track]');
    if (t.closest('[data-pm-lb-open]')) {
      var cur = currentIndex(root);
      dlg.showModal();
      requestAnimationFrame(function () { lt.scrollLeft = cur * lt.clientWidth; });
    } else if (t.closest('[data-pm-lb-close]') || t === dlg || t.classList.contains('pm-lb__stage')) {
      dlg.close();
    } else if (t.closest('[data-pm-lb-prev]')) {
      lt.scrollBy({ left: -lt.clientWidth, behavior: 'smooth' });
    } else if (t.closest('[data-pm-lb-next]')) {
      lt.scrollBy({ left: lt.clientWidth, behavior: 'smooth' });
    }
  });

  document.addEventListener('keydown', function (e) {
    var dlg = e.target.closest && e.target.closest('[data-pm-lb]');
    if (!dlg || !dlg.open) return;
    var lt = dlg.querySelector('[data-pm-lb-track]');
    if (e.key === 'ArrowLeft') lt.scrollBy({ left: -lt.clientWidth, behavior: 'smooth' });
    if (e.key === 'ArrowRight') lt.scrollBy({ left: lt.clientWidth, behavior: 'smooth' });
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-pm-option] input')) onOptionChange(t.closest('[data-pm]'));
    if (t.matches && t.matches('[data-pm-fav]')) {
      try {
        var list = JSON.parse(localStorage.getItem('db_favs') || '[]');
        var h = t.dataset.pmFav;
        list = list.filter(function (x) { return x !== h; });
        if (t.checked) list.push(h);
        localStorage.setItem('db_favs', JSON.stringify(list));
      } catch (err) {}
    }
  });

  function init() {
    document.querySelectorAll('[data-pm-fav]').forEach(function (c) {
      try { c.checked = JSON.parse(localStorage.getItem('db_favs') || '[]').indexOf(c.dataset.pmFav) > -1; } catch (err) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
